import EHRModule from "./EHRModule"

export const EHRRoutes = [
    {
    path: "ehr",
    name: "ehr-overview",
    component: EHRModule,
}
]
